import { CSSProperties, ReactNode } from 'react';
import Colors from 'modules/Colors';
import { clsx, styx } from "modules/Utils";

interface BannerProps {
    className: string;
    style?: CSSProperties;
    color?: string | 'green' | 'red' | 'purple' | 'yellow' | 'maestro';
    title?: string;
    description?: string;
    children?: ReactNode;
    iconLeft?: ReactNode;
};

const Banner = ({
    className,
    style,
    color = 'purple',
    title,
    description,
    children,
    iconLeft,
}: BannerProps) => {
    const getBackgroundColor = () => {
        switch (color) {
            case 'purple':
                return { backgroundColor: Colors.purpleLightest };
            case 'green':
                return { backgroundColor: Colors.greenLight };
            case 'yellow':
                return { backgroundColor: Colors.yellowLight };
            case 'red':
                return { backgroundColor: Colors.redTransparent };
            case 'maestro':
                return {
                    background: `url(${require('assets/images/recommendation-card-blurred-background.png').default}) no-repeat center center`,
                    backgroundSize: 'cover',
                    position: 'relative' as const,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: -2,
                        borderRadius: 18,
                        background: 'linear-gradient(45deg, rgba(138, 43, 226, 0.4), rgba(75, 0, 130, 0.4))',
                        animation: 'rotateBorder 8s linear infinite',
                        zIndex: -1
                    },
                    border: `1px solid #dddddd`
                };
            default:
                return { backgroundColor: color };
        }
    }

    const renderTitleAndIcon = () => {
        if (!title && !iconLeft) {
            return null
        }
        return (
            <div
                className="bannerIconContainer"
                style={styx(sty.bannerIconContainer)}
            >
                {iconLeft &&
                    <div
                        className="bannerIconLeft"
                        style={sty.bannerIconLeft}
                    >
                        {iconLeft}
                    </div>
                }
                {title &&
                    <div
                        className="bannerTitle"
                        style={sty.bannerTitle}
                    >
                        {title}
                    </div>
                }
            </div>
        )
    }
    return (
        <div
            className={clsx('bannerElement', className)}
            style={styx(
                sty.bannerElement,
                getBackgroundColor(),
                style
            )}
        >
            {renderTitleAndIcon()}
            {description &&
                <div
                    className="bannerDescription"
                    style={sty.bannerDescription}
                >
                    {description}
                </div>
            }
            {children}
        </div>
    );
};

export default Banner;

const sty: Record<string, CSSProperties> = {
    bannerElement: {
        borderRadius: 16,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        overflow: 'hidden',
        position: 'relative',
        width: '100%'
    },
    bannerIconContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        width: '100%'
    },
    bannerTitle: {
        fontSize: 16,
        fontWeight: 500,
        color: Colors.black,
    },
    bannerIconLeft: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
    },
    bannerDescription: {
        color: Colors.greyDark,
    }
}
